export default __webpack_public_path__ + "static/media/squre-img-lg.04247ba0.png";